<!--<panel>
<h1>Welcome to SeagrassRestorer</h1>
<p>SeagrassRestorer is a project repository for global seagrass restoration projects.</p>
<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce interdum magna hendrerit semper placerat. Nulla tempus elementum magna, quis ullamcorper elit accumsan quis. Donec ut mauris enim.</p>
<p>Nullam aliquet tortor sapien, non dignissim mi scelerisque ac. Vivamus in augue turpis. Etiam leo ligula, venenatis a lacus in, pellentesque lacinia eros. Vivamus eros tellus, pretium facilisis justo sed, bibendum porta nunc.</p>
<p class="colab">Founding Partners</p>
<div class="logos">
  <div class="logo" *ngFor="let l of logos"><img src="{{l}}"></div>
</div>
</panel>-->


<div class="panel panel-fill">
  <div class="panel-body home-panel-body">
    <div class="video-container-new">
      <video src="/spotter-shared/assets/global-images/seagrass-restorer-background.mp4" muted autoplay loop playsinline [muted]="'muted'"></video>

      <div class="overlay"></div>

      <div class="caption-new">
        <h1 class="title">SeagrassRestorer</h1>
        <p class="subtitle">A tool for knowledge sharing on seagrass restoration</p>

        @if (stats) {
          <div class="front-page-widgets">
            <front-page-widget title="Sites" [value]="stats.sites" icon="location-pin"></front-page-widget>
            <front-page-widget title="Projects" [value]="stats.projects" icon="clipboard-list"></front-page-widget>
            <front-page-widget title="Organisations" [value]="stats.organisations" icon="building"></front-page-widget>
            <front-page-widget title="Species" [value]="stats.species" icon="tag"></front-page-widget>
          </div>
        }

        <p class="colab">Founding Partners</p>
        <!--  <div class="logos">
        <div class="logo" *ngFor="let l of logos"><img src="{{l}}"></div>
      </div> -->

      <logo-slider [logos]="logos"></logo-slider>

      <!-- <div class="front-page-widgets">
      <front-page-widget title="Sightings" [value]="7544" icon="camera"></front-page-widget>
      <front-page-widget title="Users" [value]="3544" icon="user"></front-page-widget>
      <front-page-widget title="Species" [value]="32" icon="tag"></front-page-widget>
      <front-page-widget title="Countries" [value]="65" icon="earth-europe"></front-page-widget>
    </div>



    <swiper-container *ngIf="sightings"
      loop="true"
      autoplay="true"
      autoplay-delay="3500"
      autoplay-pause-on-mouse-enter="true"
      centered-slides="true"
      slides-per-view="auto"
      space-between="0"
      speed="500"
      pagination="false"
      >


      <swiper-slide *ngFor="let s of sightings; index as i" [class.swiper-slide-active]="i==0">
        <sighting [sighting]="s"></sighting>
      </swiper-slide>

    </swiper-container> -->


  </div>
</div>
</div>
</div>